import { render, staticRenderFns } from "./ReturnedItemsView.vue?vue&type=template&id=e4fdccf2&scoped=true&"
import script from "./ReturnedItemsView.vue?vue&type=script&lang=js&"
export * from "./ReturnedItemsView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnedItemsView.vue?vue&type=style&index=0&id=e4fdccf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fdccf2",
  null
  
)

export default component.exports